import * as configItems from './items'
import { AllConfigsType } from './items/types'
import { EnvVariables } from './types'
import { publicationAdjustedConfig } from './utils'

let config: AllConfigsType

const getGeneratedConfig = (envVarsObj: EnvVariables) => {
  const configItemNames = Object.keys(configItems)
  return Object.values(configItems).reduce((acc, configItem, index) => {
    acc[configItemNames[index]] = publicationAdjustedConfig(
      envVarsObj.publication,
      configItem(envVarsObj)
    )
    return acc
  }, {} as Record<string, AllConfigsType>)
}

const rawEnvVariables = {
  releaseVersion: process.env.NEXT_PUBLIC_RELEASE_VERSION,
  deploymentEnv: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV,
  publication: process.env.NEXT_PUBLIC_PUBLICATION,
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  authUrl: process.env.NEXT_PUBLIC_AUTH_URL,
  sportApiUrl: process.env.NEXT_PUBLIC_SPORT_API_URL,
  lottoUrl: process.env.NEXT_PUBLIC_LOTTO_URL,
  imageUrl: process.env.NEXT_PUBLIC_IMAGE_URL,
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL,
  staticAssetDomain: process.env.NEXT_PUBLIC_STATIC_ASSET_DOMAIN,
  staticAssetBaseUrl:
    process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'pr' &&
    !process.env.NEXT_PUBLIC_STATIC_PAGE_PR_NUMBER
      ? process.env.NEXT_PUBLIC_FALLBACK_STATIC_ASSET_BASE_URL
      : process.env.NEXT_PUBLIC_STATIC_ASSET_BASE_URL,
  staticAssetPageUrl:
    process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'pr' &&
    !process.env.NEXT_PUBLIC_STATIC_PAGE_PR_NUMBER
      ? process.env.NEXT_PUBLIC_FALLBACK_STATIC_ASSET_PAGE_URL
      : process.env.NEXT_PUBLIC_STATIC_ASSET_PAGE_URL,
  staticPageUrlSuffix:
    process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'dev' ? '.html' : '',
  weatherUrl: process.env.NEXT_PUBLIC_WEATHER_URL,
  chaptersApiUrl: process.env.NEXT_PUBLIC_CHAPTERS_API_URL,
  commentingUrl: process.env.NEXT_PUBLIC_COMMENTING_URL,
  skiTrophyUrl: process.env.NEXT_PUBLIC_SKI_TROPHY_URL,
  searchUrl: process.env.NEXT_PUBLIC_SEARCH_URL,
  recommendationsUrl: process.env.NEXT_PUBLIC_RECOMMENDATIONS_URL,
  ssoDomain: process.env.NEXT_PUBLIC_SSO_DOMAIN,
  pianoUrl: process.env.NEXT_PUBLIC_PIANO_URL,
  pianoSdkUrl: process.env.NEXT_PUBLIC_PIANO_SDK_URL,
  videoMetadataUrl: process.env.NEXT_PUBLIC_VIDEO_METADATA_URL,
}

const isValidEnvVariables = (config: any): config is EnvVariables =>
  ['blick', 'romandie'].includes(config.publication) &&
  ['dev', 'pr', 'test', 'stg', 'prod'].includes(config.deploymentEnv)

if (isValidEnvVariables(rawEnvVariables)) {
  config = getGeneratedConfig(rawEnvVariables) as unknown as AllConfigsType
} else {
  config = {} as AllConfigsType
  console.error('Environment variables provided do not result in valid config!')
}

export default config
